export default __webpack_public_path__ + "static/media/team-dark.eb360b46.mp4";